import {
  Autocomplete,
  Box,
  createFilterOptions,
  FormControl,
  TextField,
  Typography,
  useTheme,
} from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { IMonitoring } from '../../shared/interfaces/IMonitoring';

interface Props {
  disabled?: boolean;
  value: IMonitoring | null;
  options: IMonitoring[];
  onChange: (value: IMonitoring | null) => void;
}

// The sub-label carries the location (e.g. for gmb), so searching by address works too.
const filterOptions = createFilterOptions<IMonitoring>({
  stringify: (option) => `${option.label} ${option.subLabel ?? ''}`,
});

const MonitoringLabelFilter: FC<Props> = ({ disabled, value, options, onChange }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  return (
    <FormControl
      disabled={disabled}
      size="small"
      sx={{ minWidth: '284px', mt: theme.spacing(2), mb: theme.spacing(1) }}
    >
      <Autocomplete
        value={value}
        getOptionLabel={(option) => option.label}
        getOptionKey={(option) => `${option.company}_${option.platformId}`}
        options={options}
        filterOptions={filterOptions}
        renderOption={({ key, ...optionProps }, option) => (
          <Box
            key={key}
            component="li"
            {...optionProps}
          >
            <Box>
              <Typography>{option.label}</Typography>
              {option.subLabel && (
                <Typography sx={{ fontSize: '10px' }}>{`(${option.subLabel})`}</Typography>
              )}
            </Box>
          </Box>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            label={t('monitoring_label')}
          />
        )}
        onChange={(event, newValue) => onChange(newValue)}
      />
    </FormControl>
  );
};

export default MonitoringLabelFilter;
